import request from '../utils/request'
import QS from "qs";

export function getListData (data) {
  return request({
    url: '/api/plant-show',
    method:'get',
    params:data,
  })
}
export function factoryDes (id,data) {
  return request({
    url: `/api/plant-show/${id}`,
    method: 'get',
    params:data
  })
}
export function getWechat (data){ // 订阅获取消息
  return request({
    url: '/api/wechat/config',
    method: 'post',
    data:QS.stringify(data),
  })
}
